module.exports = __webpack_public_path__ + "img/emoji_kuxiao.f6ecf191.png";